import host from '../host';

export default async function get_size(){
  let customer = window.customerId;
  if(customer){
    let response = await fetch(
      host + `/api/customer_sizes/${customer}/`,
    );
    if(response.ok){
      let json = await response.json();
      return json['size'];
    }
  }
}
